<template>
  <li class="octadesk-chat-survey-response">
    <div class="octadesk-chat-survey-body">
      <div v-if="!isNotAnswered" class="survey-buttons-container">
        <p class="survey-buttons-title" v-html="surveyTitle" />

        <div class="survey-options">
          <label class="survey-options-item static">
            <div class="survey-options-item-img-out">
              <img
                v-if="!isUnsatisfied"
                src="@/css/images/survey/down-gray.svg"
                alt=""
                width="48px"
                height="48px"
              />
            </div>

            <div class="survey-options-item-img-over">
              <img
                v-if="isUnsatisfied"
                src="@/css/images/survey/down-color.svg"
                alt=""
                width="48px"
                height="48px"
              />
            </div>
          </label>

          <label class="survey-options-item static">
            <div class="survey-options-item-img-out">
              <img
                v-if="!isSatisfied"
                src="@/css/images/survey/up-gray.svg"
                alt=""
                width="48px"
                height="48px"
              />
            </div>

            <div class="survey-options-item-img-over">
              <img
                v-if="isSatisfied"
                src="@/css/images/survey/up-color.svg"
                alt=""
                width="48px"
                height="48px"
              />
            </div>
          </label>
        </div>
      </div>

      <transition name="slideup-fade">
        <div
          v-if="hasComment"
          class="survey-textarea-container box-shadowed--card space-top-md"
        >
          <p class="survey-textarea-title">
            <span v-html="$sanitizeHtml($t('survey.yourSurvey'))" />
          </p>

          <p
            class="chat-survey-comment"
            :style="`color: rgba(${settings.fontColorRGBA}); background-color: rgba(${settings.bgColorRGBA}`"
          >
            {{ chatSurvey.comment }}
          </p>
        </div>
      </transition>

      <transition name="slideup-fade">
        <div
          v-if="!isNotAnswered"
          class="box-shadowed--card sucess-reponse--survey space-top-md"
        >
          <div class="survey-ok-icon-block">
            <img
              src="@/css/images/survey/check.svg"
              alt=""
              width="40px"
              height="40px"
            />
          </div>

          <div class="text-center text-bold">
            <b>{{ $t('survey.sent') }}</b>
          </div>

          <div class="text-center">{{ $t('survey.thanksForYourReview') }}</div>
        </div>
      </transition>

      <div
        v-if="isNotAnswered"
        class="survey-textarea-container box-shadowed--card space-top-md"
      >
        <div v-if="isNotAnswered" class="survey-ok-icon-block">
          <img
            src="@/css/images/survey/check.svg"
            alt=""
            width="40px"
            height="40px"
          />
        </div>

        <div class="text-center">{{ $t('survey.thanks') }}</div>
      </div>
    </div>
  </li>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters(['chatSurvey', 'settings', 'fluxSurvey']),
      surveyTitle() {
        if (this.fluxSurvey && this.fluxSurvey.title) {
          return this.$sanitizeHtml(this.fluxSurvey.title)
        }

        return this.$sanitizeHtml(this.$t('survey.title'))
      },
      isNotAnswered() {
        return this.chatSurvey.response === 'not_answered'
      },
      isSatisfied() {
        return this.chatSurvey.response === 'satisfied'
      },
      isUnsatisfied() {
        return this.chatSurvey.response === 'unsatisfied'
      },
      hasComment() {
        return !!this.chatSurvey.comment
      }
    }
  }
</script>

<style>
  .octadesk-chat-survey-response {
    position: relative;
    width: 100%;
    min-height: 255px;
    margin: 1.5rem auto;
    font-size: 0.875rem;
  }

  .octadesk-chat-survey-response:after {
    position: relative;
    content: '.';
    display: block;
    width: 0;
    height: 0;
    color: transparent;
    font-size: 0;
    clear: both;
  }

  .survey-response-body {
    width: 200px;
    min-height: 90px;
    margin: 0 auto 1.5rem auto;
    padding: 1rem;
    font-size: 0.875rem;
    box-shadow: 0px 0px 9px 3px rgba(0, 0, 0, 0.1);
    border-radius: 0.315rem;
  }

  .survey-response-label {
    padding: 4px 12px;
    margin-bottom: 12px;
    border-radius: 16px;
    width: auto;
    display: inline-block;
    font-size: 14px;
  }

  .survey-response-title {
    margin-top: 0;
    font-size: 0.75rem;
    text-align: center;
  }

  .survey-response-title {
    font-weight: bold;
  }

  .survey-response-comment {
    position: relative;
    display: block;
    padding: 0.3rem 0 0 35px;
    margin-bottom: 0;
    font-size: 0.75rem;
    min-height: 30px;
    word-break: break-all;
  }

  .survey-response-comment span {
    position: absolute;
    left: 0;
    top: 5px;
  }

  .survey-response-end-message {
    width: 100%;
    position: relative;
    clear: both;
  }

  .survey-comment {
    font-size: 12px;
    color: #999;
  }

  .selected svg {
    fill: #ffcc4d;
  }

  .survey-buttons-container {
    margin-bottom: 10px;
    border-radius: 5px 30px 30px 0px;
  }

  .box-shadowed--card {
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
    width: 100%;
    background: #fff;
    padding: 0.5rem 0.95rem;
    margin: 0 0 0.5rem 0;
    font-size: 0.875rem;
    border-radius: 5px 30px 30px 30px;
  }

  .sucess-reponse--survey {
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-direction: column;
    padding: 20px;
  }
  .sucess-reponse--survey p {
    font-size: 14px;
    color: #525252;
    font-weight: 400;
    margin: 10px 0px 0px 0px;
  }
  .sucess-reponse--survey p strong {
    font-weight: 700;
  }

  .btn-satisfeito--reponse svg,
  .btn-insatisfeito--reponse svg {
    fill: #ccc;
    transition: fill 0.2s ease-in,
      transform 0.3s cubic-bezier(0.8, -0.12, 0.4, 1.7);
  }

  .btn-satisfeito--response.selected svg,
  .btn-insatisfeito--response.selected svg {
    fill: #ffcc4d;
  }

  .survey-textarea-container {
    width: 100%;
    background: #fff;
    padding: 0.5rem 0.95rem;
    margin: 0 0 0.5rem 0;
    font-size: 0.875rem;
    border-radius: 5px 30px 30px 5px;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
  }

  .survey-textarea-wrapper {
    position: relative;
    width: 100%;
    min-height: 16px;
    max-height: 9.375rem;
    margin: 0 auto 0.5rem auto;
    border: none !important;
    margin-top: 10px;
  }

  p.chat-survey-comment {
    width: 100%;
    font-size: 12px;
    line-height: 21px;
    padding: 10px;
    border-radius: 10px;
  }
</style>
